"use client";

import * as stylex from "@stylexjs/stylex";
import { CrashScreen } from "@/shell/CrashScreen";
import { geistMono, geistSans } from "@/theme/fonts";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import "./globals.css";
export default function GlobalError({
  error
}: {
  error: Error;
}) {
  return <html lang="en" className={`${geistSans.variable} ${geistMono.variable}`}>
      <body className="x1ghz6dp x17jlq2w x381olo xvmahel">
        <CrashScreen error={error} />
      </body>
    </html>;
}